// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph {
  --vis-graph-node-label-font-size: 8pt;
  --vis-graph-node-label-text-color: #717179;

  --vis-graph-node-sublabel-font-size: 9pt;
  --vis-graph-node-sublabel-text-color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/examples/networks-and-flows/graph/graph-custom-icons/index.module.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0CAA0C;;EAE1C,wCAAwC;EACxC,6CAA6C;AAC/C","sourcesContent":[".graph {\n  --vis-graph-node-label-font-size: 8pt;\n  --vis-graph-node-label-text-color: #717179;\n\n  --vis-graph-node-sublabel-font-size: 9pt;\n  --vis-graph-node-sublabel-text-color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graph": `graph`
};
export default ___CSS_LOADER_EXPORT___;
